import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CpExamination } from '@se/models';
import { BoolIconRendererIconType, GridUtilitiesService } from '@se/platform';
import { ServerRootService } from '@se/se.ui.html5';
import { ColDef } from 'ag-grid-community';
import { Observable } from 'rxjs';

export interface ExaminationsFilter {
    name?: string;
    surname?: string;
    date?: any;
    idPatient?: string
}

@Injectable({
    providedIn: 'root'
})
export class AddExamService extends ServerRootService {
    constructor(private httpClient: HttpClient, private translate: TranslateService, private gridUtils: GridUtilitiesService) {
        super();
    }

    addExam(idReport: string, idExaminations: string[]) {
        return this.httpClient.post(this.getServerRoot() + '/Visit/AddExaminationsToReport', { idReport, idExaminations }, this.buildOptions());
    }

    search(searchOptions: ExaminationsFilter): Observable<CpExamination[]> {
        return this.httpClient.post<CpExamination[]>(
            this.getServerRoot() + '/Visit/GetExaminationsToAdd', searchOptions, this.buildOptions()
        );
    }

    buildColumns(): ColDef[] {
        return [
            {
                colId: 'ExamOutOfFlow',
                headerName: '',
                tooltipField: '',
                field: 'patient.isLocalPatient',
                width: 50,
                suppressSizeToFit: true,
                resizable: false,
                lockPosition: true,
                pinned: 'left',
                cellStyle: { padding: '0', display: 'flex', justifyContent: 'center', marginLeft: '5px' },
                cellRenderer: 'boolIconRenderer',
                cellRendererParams: {
                    estensa: {
                        iconType: BoolIconRendererIconType.SeFont,
                        icon: 'icon_flusso_inverso',
                        tooltip: 'PatientDataNotAssociated',
                    },
                },
            },
            {
                colId: '0',
                headerName: this.translate.instant('Patient'),
                headerTooltip: this.translate.instant('Patient'),
                valueGetter: e =>
                    `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
                tooltipValueGetter: e =>
                    `${e.data.patient.lastName.toLocaleUpperCase()} ${e.data.patient.firstName.toLocaleUpperCase()}`,
                width: 200,
                minWidth: 190,
                suppressSizeToFit: true,
                lockPosition: true,
                pinned: 'left',
                cellStyle: e => {
                    return null;
                }
            },
            {
                colId: '1',
                headerName: this.translate.instant('BirthDate'),
                headerTooltip: this.translate.instant('BirthDate'),
                tooltipField: 'patient.birthDate',
                field: 'patient.birthDate',
                width: 155,
                minWidth: 120,
                valueFormatter: this.gridUtils.dateFormatter(["patient", "birthDate"]),
                comparator: this.gridUtils.dateComparator,
            },
            {
                colId: '2',
                headerName: this.translate.instant('ExamDate'),
                headerTooltip: this.translate.instant('ExamDate'),
                tooltipField: 'examinationDate',
                field: 'examinationDate',
                width: 135,
                minWidth: 120,
                valueFormatter: this.gridUtils.dateTimeFormatter('examinationDate'),
                comparator: this.gridUtils.dateComparator,
            },
            {
                colId: '3',
                headerName: this.translate.instant('Exam'),
                headerTooltip: this.translate.instant('Exam'),
                tooltipField: 'exam.description',
                field: 'exam.description',
                width: 220,
                minWidth: 190
            },
            {
                colId: '4',
                headerName: this.translate.instant('Status'),
                headerTooltip: this.translate.instant('Status'),
                tooltipField: 'status',
                field: 'status',
                width: 100,
                minWidth: 100
            },
            {
                colId: '5',
                headerName: this.translate.instant('BusinessUnit'),
                headerTooltip: this.translate.instant('BusinessUnit'),
                tooltipField: 'businessUnit.description',
                field: 'businessUnit.description',
                width: 220,
                minWidth: 190
            }
        ];
    }
}
